import { alpha } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import { COLORS } from 'muiTheme/colors';
import type { ElementType } from 'react';

export const EventIcon = ({ icon }: { icon: ElementType }) => {
  const IconComponent = icon;
  const isMuiSvgIcon = (IconComponent as { muiName?: string }).muiName === 'SvgIcon';

  return (
    <Avatar sx={{ width: '32px', height: '32px', backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.04), border: 'none' }}>
      {isMuiSvgIcon ? (
        <IconComponent htmlColor={COLORS.appFog800} width="24px" height="24px" />
      ) : (
        <IconComponent color={COLORS.appFog800} width="24px" height="24px" />
      )}
    </Avatar>
  );
};
